import { render, staticRenderFns } from "./KeyKeeperColorSelect.vue?vue&type=template&id=1087d343&scoped=true&"
import script from "./KeyKeeperColorSelect.vue?vue&type=script&lang=ts&"
export * from "./KeyKeeperColorSelect.vue?vue&type=script&lang=ts&"
import style0 from "./KeyKeeperColorSelect.vue?vue&type=style&index=0&id=1087d343&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1087d343",
  null
  
)

export default component.exports